module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<a class="cell-link" href="#" data-url="' +
__e( data.content ) +
'" data-trigger="hover" data-toggle="tooltip" data-placement="top" title="' +
__e( data.tooltip ) +
'">\n';
 if (data.icon) { ;
__p += '\n    <i class="' +
__e( data.icon ) +
'"></i>\n';
 } else { ;
__p += '\n    ' +
((__t = ( data.content )) == null ? '' : __t) +
'\n';
 } ;
__p += '\n</a>\n';
return __p
}